import { useTranslation } from 'react-i18next';

export default function ReportDisclaimer() {
  const { t } = useTranslation();

  return (
    <div className="mt-8 pt-6 border-t border-border" data-testid="report-disclaimer">
      <p className="text-xs text-muted-foreground leading-relaxed">{t('trust.disclaimer')}</p>
      <p className="text-xs text-muted-foreground mt-2">{t('trust.privacyNotice')}</p>
    </div>
  );
}
